import { PROFILE } from "../assets/constants/route_path";
import { IUser } from "../models/user.model";

export const getDefaultAuthenticatedRoute = (user: IUser): string => {
    switch (true) {
        default:
            return PROFILE;
    }
}
